import React, {useRef, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import * as yup from 'yup';
import {t} from 'react-switch-lang';
import {validNameandNumberEngMneRegex} from '../../../../utils/const';
import {Toast} from '../../../../utils/sweetAlert';
import {
  createExternalizationDocumentTemplates,
} from '../../../../services/externalizations/externalizationTemplatesServices';
import {Col, Row} from 'react-bootstrap';
import Label from 'reactstrap/lib/Label';
import InputText from '../../../../components/FormFields/InputText';
import FileUploadSection from '../../../../components/FileUploadSection/FileUploadSection';
import allowedFileTypes from '../../../../utils/allowedFileTypes';

const AddExternalizationTemplates = (props) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [files, setFiles] = useState();
  const isSubmittingRef = useRef(false);
  const schema = yup.object().shape({
    name: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .matches(validNameandNumberEngMneRegex, t('message.fieldNotValid'))
      .max(100, `${t('message.max', {max: 100})}`)
      .min(3, `${t('message.min', {min: 3})}`),
    nameEn: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .matches(validNameandNumberEngMneRegex, t('message.fieldNotValid'))
      .max(100, `${t('message.max', {max: 100})}`)
      .min(3, `${t('message.min', {min: 3})}`),
    template: yup
        .mixed()
        .test('fileRequired', t('message.fieldRequired'), value => {
          return files && files.length > 0;
        }),
  });
  const methods = useForm({
    resolver: yupResolver(schema),
  });
  const {handleSubmit, watch,clearErrors, errors, register, setValue} = methods;

  const submitForm = (data) => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsButtonDisabled(true);
    const formData = new FormData();
    formData.append('externalizationDocumentTemplateDTO', JSON.stringify({
      name: data.name,
      nameEn: data.nameEn,
    }));
    formData.append('templateFile', data.file[0]);
    createExternalizationDocumentTemplates(formData).then((res) => {
      Toast.fire({
        icon: 'success', title: `${t('message.successAdd')}`,
      });
      props.setRowChanged();
      props.toggleModal();
      setFiles();
      setValue('name', '');
      setValue('nameEn', '');
      setValue('template', null);
      setIsButtonDisabled(false);
    }).catch((err) => {
      setIsButtonDisabled(false);
    })
  };
  const handleCancel = (e) => {
    e.preventDefault();
    props.toggleModal();
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitForm)}>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="name"> {t("departments.name")}</Label>
            <InputText
              type="text"
              id="name"
              name="name"
              className={
                "form-control " +
                (errors.name !== undefined ? "error-field" : "")
              }
              placeholder={t("departments.placeholder.name")}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="nameEn"> {t("departments.nameEn")}</Label>
            <InputText
              type="text"
              id="nameEn"
              name="nameEn"
              className={
                "form-control " +
                (errors.nameEn !== undefined ? "error-field" : "")
              }
              placeholder={t("departments.placeholder.nameEn")}
            />

          </Col>
          <Col sm={12}>
          <label style={{minHeight: '50px'}} className="label d-flex align-items-end w-100 mt-2">
            {t('externalization.riskProponentForm.file')}
          </label>
            <FileUploadSection
              className={'template'}
              allowedFileTypes={allowedFileTypes}
              multiple={false}
              fetchedFiles={files?.template ? [{ id: files?.template?.id, fileName: files?.template?.name }] : []}
              isUploading={isUploading}
              onDeleteFetchedFile={(e) => {
                e.preventDefault();
                setFiles(undefined);
                setValue('template', null);
              }}
              onNewFilesChange={(file) => {
                setIsUploading(true);
                clearErrors('template')
                setFiles(file);
                setValue('template', file);
                setIsUploading(false);
              }}
              fieldName="template"
              setValue={setValue}
              register={register}
              error={errors?.template?.message}
            />
          </Col>
        </Row>
        <Row className="submit-buttons-container mx-0">
          <Col sm={12} className="text-right px-0">
            <div className="submit">
              <button
                className="primary cancel"
                type="reset"
                onClick={(e) => handleCancel(e)}>
                {t("buttons.cancelBtn")}
              </button>
              <button className="primary">
                  {(isUploading || isButtonDisabled) ? (
                    <>
                      <span className="spinner-border spinner-border-sm mr-2" />
                      {t("buttons.saveBtn")}
                    </>
                  ) : (
                    t("buttons.saveBtn")
                  )}
                </button>
            </div>
          </Col>
        </Row>
      </form>
    </FormProvider>
  );
};

export default AddExternalizationTemplates;